import { useEffect, useState } from "react";

// import { demoPayloads } from "../data/demoPayloads";
import { ClauseCoverageCard } from "../components";
import EventDetail from "../components/EventDetail";
import ActiveGaps from "../components/ActiveGaps";
import ReadinessHeader from "../components/ReadinessHeader";
import { artifactToCompliancePayload } from "../utils/artifactToCompliancePayload";
import { groupEvents } from "../utils/groupEvents";

export default function AuditDashboard() {

  const [dashboard, setDashboard] = useState([]);
  const [events, setEvents] = useState([]);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [groupedEvents, setGroupedEvents] = useState([]);

  useEffect(() => {
    fetchDashboard();
  }, []);

  const fetchDashboard = async () => {

    try {

      const savedArtifacts = 
      JSON.parse(
        localStorage.getItem("fluxonix_artifacts")
      ) || [];

      const payloads = savedArtifacts.map(
        artifactToCompliancePayload
      );

      console.log(
        "Saved Artifacts:",
        savedArtifacts
     );

    console.log(
       "Compliance Payloads:",
       payloads
     );

      const response = await fetch(
        "http://localhost:8000/compliance/dashboard",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            payloads
            })
        }
      );

    

      const data = await response.json();
      console.log("Dashboard response:", data);

      const grouped = groupEvents(data.events);
      console.log("Grouped Events:", grouped);

      setDashboard(data.dashboard);
      setEvents(data.events);
      setGroupedEvents(grouped);

      if (grouped.length > 0) {
        setSelectedEvent(grouped[0]);
      }
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div className="min-h-screen bg-gray-100 p-6">

      <ReadinessHeader
        events={events}
        dashboard={dashboard}
    />

      <div className="grid grid-cols-12 gap-6">

        <div className="col-span-4 bg-white rounded-xl border p-4">
          <h2 className="text-xl font-semibold mb-4">
            Operational Events
          </h2>

          {groupedEvents.map((event, idx) => (

            <div
                key={idx}
                onClick={() => setSelectedEvent(event)}
                className="
                border
                rounded-lg
                p-4
                mb-3
                cursor-pointer
                hover:bg-gray-50
                "
            >

                <div className="text-xs text-gray-400 mb-2">
                10:{idx + 1}4 AM
                </div>

                {/* Event Title */}

                <div className="font-medium">
                Operational Event
                </div>

                {/* Clauses */}

                <div className="flex flex-wrap gap-2 mt-2">

                {(event.clauses || []).map((clause, clauseIdx) => (

                    <div
                    key={clauseIdx}
                    className="
                        px-2
                        py-1
                        bg-red-100
                        text-red-700
                        rounded-full
                        text-xs
                    "
                    >
                    AS9100 {clause}
                    </div>

                ))}

                </div>

                {/* Transcript Preview */}

                <div className="text-sm text-gray-600 mt-3 line-clamp-3">

                {
                    event.transcript ||
                    event.payload?.transcript ||
                    "No transcript available"
                }

                </div>

                {/* Coverage */}

                <div className="mt-3 text-sm">

                Coverage:

                <span className="font-semibold ml-1">

                    {
                    event.checklist?.coverage_percent || 0
                    }%

                </span>

                </div>

                {/* Signal Count */}

                <div className="mt-2 text-xs text-gray-500">

                {(event.complianceSignals || []).length}
                {" "}
                compliance signal(s)

                </div>

            </div>

            ))}
        </div>

        <div className="col-span-8 space-y-6">

        <div>

            <h2 className="text-xl font-semibold mb-4">
            Audit Readiness
            </h2>

            <div className="grid grid-cols-2 gap-4">

            {dashboard.map((clause, idx) => (
                <ClauseCoverageCard
                key={idx}
                clause={clause}
                />
            ))}

            </div>

        </div>

        <ActiveGaps events={events} />
        <EventDetail event={selectedEvent} />

        </div>

      </div>

    </div>
  );
}